/**
 * PURPOSE: Panel lateral deslizante del Centro de Programación (FTR-0028 WG3).
 * RESPONSIBILITIES: Alojar los flujos secundarios —configuración, materialización, reorganización,
 *   partido manual, participantes— sobre la misma pantalla.
 *
 *   UN MODAL, PANELES LATERALES (contrato §15). Apilar modales encima del Centro obligaría a cerrar
 *   en orden inverso y escondería el contexto sobre el que se está decidiendo. El panel deja las
 *   filas a la vista mientras se revisa un impacto, que es justo cuando hace falta mirarlas.
 * COLLABORATORS: Los paneles de panels/, ProgrammingCenterModal.jsx.
 * ROUTE: winscore/src/area/FasesArea/ProgrammingCenter/components/SidePanel.jsx
 */
import React from "react";
import { FiX } from "react-icons/fi";

const SidePanel = ({ open, onClose, title, subtitle = null, footer = null, children }) => {
  if (!open) return null;

  return (
    <aside
      role="dialog"
      aria-label={title}
      className="absolute inset-y-0 right-0 z-30 flex w-full max-w-xl flex-col border-l border-slate-200 bg-white shadow-2xl"
    >
      <header className="flex items-start justify-between gap-3 border-b border-slate-200 px-4 py-3">
        <div className="min-w-0">
          <h3 className="truncate text-base font-black text-slate-900">{title}</h3>
          {subtitle ? (
            <p className="truncate text-[11px] font-bold text-slate-500">{subtitle}</p>
          ) : null}
        </div>
        <button
          type="button"
          onClick={onClose}
          aria-label="Cerrar panel"
          className="shrink-0 rounded-lg border border-slate-200 p-1.5 text-slate-500 transition hover:border-rose-300 hover:text-rose-600"
        >
          <FiX className="text-sm" />
        </button>
      </header>

      <div className="flex-1 overflow-y-auto px-4 py-4">{children}</div>

      {footer ? (
        <footer className="border-t border-slate-200 bg-slate-50 px-4 py-3">{footer}</footer>
      ) : null}
    </aside>
  );
};

export default SidePanel;
